import $ from 'jquery';
require("jquery-mousewheel")($);

import Menu from './modules/global-menu';
import Overlay from './modules/menu-overlay';
import Search from './modules/global-search';

jQuery(document).ready(function($) {
  let GlobalMenu = new Menu();
  let OverlayMenu = new Overlay();
  let GlobalSearch = new Search();
})